import Vue from 'vue'

import UIButton from '@/components/ui-button'
import NC from '@/lib/notification-center'

import utils from '@/lib/utils'

export default  {
  name: 'project',
  props: {
    project: {
      type: Object
    },
    type: {
      type: String,
      default: 'project'
    }
  },
  data() {
    return {
      visited: false
    }
  },
  computed: {
    isArchive() {
      return (this.type == 'archive');
    }
  },
  mounted() {

    // Vue.nextTick(() => {
    //   this.wrapLetters();
    // });

    this.visited = this.getVisited() ? true : false;
  },
  components: {
    'ui-button': UIButton
  },

  methods: {

    getVisited() {
      return Vue.localStorage.get(this.$props.project.id);
    },

    setVisited(visited) {
      this.$data.visited = visited;
      Vue.localStorage.set(this.$props.project.id, visited);
      utils.setStorageIdNow();
    },

    wrapLetters() {
      if(!this.isArchive) {
        const txt = this.$refs.title.innerText;
        this.$refs.title.innerHTML = txt.replace(/./g, "<span>$&</span>");
      }
    },

    _onClickButton(e) {
      ga('set', 'page', this.project.title.toLowerCase());
      ga('send', 'pageview');
      this.setVisited(true);
      if(this.project.soon) {
        e.preventDefault();
        return false;
      }
      if(!this.project.live) {
        e.preventDefault();
        this.store.currentModal = this.db.modals[this.project.id];
        this.store.showModal = true;
      }
    },
    
    _onMouseEnter(e) {
      NC.emit('project:hover', {show: true, project: this.$props.project, position: {x: e.clientX, y: e.clientY}});
    },
    
    _onMouseLeave(e) {
      NC.emit('project:hover', {show: false, project: this.$props.project});
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/project/project.component.js